const profile = {
    name: "Ім'я",
    avatar: 'Аватар',
    givenName: "Ім'я",
    familyName: 'Прізвище',
    middleName: 'По батькові',
    fullName: "Повне ім'я",
    nickname: 'Псевдонім',
    preferredUsername: "Бажане ім'я користувача",
    profile: 'Профіль',
    website: 'Вебсайт',
    gender: 'Стать',
    birthdate: 'Дата народження',
    zoneinfo: 'Часовий пояс',
    locale: 'Локаль',
    address: {
        formatted: 'Адреса',
        streetAddress: 'Вулиця',
        locality: 'Місто',
        region: 'Штат/Область',
        postalCode: 'Поштовий індекс',
        country: 'Країна',
    },
};
export default Object.freeze(profile);
